import { Payment, PaymentInformation } from '../../types';
import { PayorType } from '../constants';
import { getInitialPayorData } from './payor';

export const getInitialPaymentData = (paymentIndex?: number): Payment => {
  return {
    id: paymentIndex !== undefined ? `payment-${paymentIndex}` : `payment-${Date.now()}`,
    amount: 0,
    paymentMethod: '',
    fromFinancialInstitution: true,
    accountNumber: '',
    financialInstitutionName: '',
    associatedWithAllTransferees: true,
    associatedTransfereeNames: [],
    allPayorsAreTransferees: false,
    payors: [getInitialPayorData(PayorType.INDIVIDUAL, 0)],
  };
};

export const getInitialPaymentInformationData = (): PaymentInformation => {
  return {
    considerationEnabled: true,
    totalConsideration: 0,
    hasHardMoneyLoan: false,
    payments: [getInitialPaymentData()],
  };
};

export const validatePayment = (payment: Payment): boolean => {
  if (payment.amount === 0 || !payment.paymentMethod) {
    return false;
  }

  if (payment.paymentMethod === 'OTHER' && !payment.otherPaymentMethodDescription) {
    return false;
  }

  if (payment.paymentMethod === 'FOREIGN_CURRENCY') {
    if (!payment.currencyCode) {
      return false;
    }
    if (payment.currencyCode === 'NOT_LISTED' && !payment.currencyNotListedDescription) {
      return false;
    }
  }

  if (!payment.accountNumber || !payment.financialInstitutionName) {
    return false;
  }

  if (!payment.associatedWithAllTransferees && payment.associatedTransfereeNames.length === 0) {
    return false;
  }

  if (!payment.allPayorsAreTransferees && payment.payors.length === 0) {
    return false;
  }

  return true;
};

export const validatePaymentInformation = (paymentInfo: PaymentInformation): boolean => {
  if (paymentInfo.considerationEnabled) {
    if (paymentInfo.totalConsideration <= 0) {
      return false;
    }

    if (paymentInfo.hasHardMoneyLoan) {
      if (!paymentInfo.hardMoneyLoanType) {
        return false;
      }
      if (paymentInfo.hardMoneyLoanType === 'OTHER' && !paymentInfo.hardMoneyLoanOtherDescription) {
        return false;
      }
    }
  }

  if (paymentInfo.payments.length === 0) {
    return false;
  }

  return paymentInfo.payments.every(validatePayment);
};
